import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  languages,
  selectedLanguage,
} from '../../shared/components/header/elements/languages/languages.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/auth-api/user.service';
import { PasswordResetRequest } from '../../services/auth-api/requests';
import { BaseResponseError } from '../../services/models/base.model';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss',
  standalone: false,
})
export class PasswordResetComponent {
  public form: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private translate: TranslateService,
    private toastrService: ToastrService,
    private userService: UserService
  ) {
    let lang =
      languages.find(
        (x) =>
          x.code.includes(navigator.language) ||
          navigator.language.includes(x.code)
      ) || selectedLanguage;
    this.translate.use(lang.code);
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(255)],
      ],
    });
  }

  passwordReset() {
    if (this.form.valid) {
      this.loading = true;
      this.userService.passwordReset(new PasswordResetRequest(this.form.controls.email.value))
      .subscribe({
        next: ({ data }) => {
          this.loading = false;
          this.toastrService.success(
            `<p>${data}</p>`,
            '',
            {
              closeButton: true,
              enableHtml: true,
              positionClass: 'toast-bottom-right',
            }
          );
          this.router.navigate(['/auth/reset-password']);
        },
        error: (error) => {
          this.loading = false;
          console.error(error);
          if (error.error?.errors) {
            (error.error.errors as Array<BaseResponseError>)?.map(({ message }) => {
              this.toastrService.error(message, '', {
                closeButton: true,
                enableHtml: true,
                positionClass: 'toast-bottom-right',
              });
            });
          }
        },
      });
    }
  }
}
